import jwtDecode from 'jwt-decode';
import {TOKEN_OBTAIN_PAIR_SUCCESS, TOKEN_REFRESH_SUCCESS, TOKEN_OBTAIN_PAIR_ERROR, TOKEN_REFRESH_ERROR} from '../actions/auth';

/* Auth0 Payload {
    sub: "auth0|5aa05120864b1f3b2078d782",
    nickname: "etienne",
    name: "etienne@webmaestro.fr",
    picture: "https://s.gravatar.com/avatar/8aaaef6022e6f616b8f75b3a76a06862?s=480&r=pg&d=https%3A%2F%2Fcdn.auth" +
            "0.com%2Favatars%2Fet.png",
    updated_at: "2018-03-07T20:54:49.903Z"
} */

export default(state = {
    access: null,
    refresh: null,
    errors: {}
}, action) => {
    switch (action.type) {
        case TOKEN_OBTAIN_PAIR_SUCCESS:
            return {
                access: {
                    token: action.payload.access,
                    ...jwtDecode(action.payload.access)
                },
                refresh: {
                    token: action.payload.refresh,
                    ...jwtDecode(action.payload.refresh)
                },
                errors: {}
            };
        case TOKEN_REFRESH_SUCCESS:
            return {
                ...state,
                access: {
                    token: action.payload.access,
                    ...jwtDecode(action.payload.access)
                },
                errors: {}
            };
        case TOKEN_OBTAIN_PAIR_ERROR:
        case TOKEN_REFRESH_ERROR:
            return {
                access: null,
                refresh: null,
                errors: action.payload.response || {
                    'submit': action.payload.statusText
                }
            };
        default:
            return state;
    }
}

export const authAccessToken = (auth) => auth.access && auth.access.token,
    authRefreshToken = (auth) => auth.refresh && auth.refresh.token,
    authErrors = (auth) => auth.errors || {},
    isAccessTokenExpired = (auth) => auth.access && auth.access.exp
        ? 1000 * auth.access.exp - (new Date()).getTime() < 5000
        : true,
    isRefreshTokenExpired = (auth) => auth.refresh && auth.refresh.exp
        ? 1000 * auth.refresh.exp - (new Date()).getTime() < 5000
        : true,
    isAuthenticated = (auth) => !isRefreshTokenExpired(auth),
    withAuth = (headers = {}) => (auth) => ({
        ...headers,
        'Authorization': `Bearer ${authAccessToken(auth)}`
    });


// WEBPACK FOOTER //
// ./src/reducers/auth.js